import './commonAssets';

import '../common/modules/stock/collections/tabbed-stock-collections.less';
import '../common/stylesheets/modules/collections/collection-browse.less';
import '../common/stylesheets/modules/widgets/stock-item-group-widget-card-design-v2.less';
import '../common/stylesheets/modules/widgets/stock-item-group-widget-card-design.less';
import '../common/stylesheets/modules/widgets/stock-item-group-widget.less';
import '../global/components/storyblocks-collection-browse.less';
import '../global/tools/mixins.less';
import '../graphicstock/components/markup-mixins.less';
import '../graphicstock/modules/search/searchResults.less';


import AppLoader from '../react/AppLoader/AppLoader';
import NPSModalLoaderContainer from '../react/NPSModalLoader/NPSModalLoaderContainer';
import ReactToastifyContainer from '../react/ReactToastify/containers/ReactToastifyContainer';
import StockItemCollectionContainer from '../react/app/Search/containers/StockItemCollectionContainer';
import PopUpsContainer from '../react/PopUps/PopUpsContainer';
import ImageSiteConstants from '../react/common/SiteConstants/ImageSiteConstants';
import EntTrialBanner from "../react/Trials/EntTrialBanner";
import NavApps from "../react/app/NavApps";

AppLoader.load({
  routes: [
    {
      name: 'Collection',
      path: new ImageSiteConstants().getCollectionsRoute(),
      component: StockItemCollectionContainer,
    },
  ],
  auxApps: {
    ...NavApps,
    'pop-up-container': PopUpsContainer, // FIXME: causes missing matching <div> in <section>
    'nps-modal': NPSModalLoaderContainer,
    'react-toastify-container': ReactToastifyContainer, // FIXME: causes missing matching <div> in <section>
  },
  propBasedApps: {
    'entTrialBanner': EntTrialBanner
  },
});
